import { Breakpoint, useBreakpoint } from "cenero-ui-library";
import ModalWrapper from "@/components/shared/ModalWrapper";
import BookingCheckout from "./BookingCheckout";

// ---------------------- Interface

interface BookingCheckoutWrapperProps {
  parentRoute: string;
}

// ---------------------- Component

const BookingCheckoutWrapper = ({ parentRoute }: BookingCheckoutWrapperProps) => {
  // --------- Variables / Hooks

  const breakpoint = useBreakpoint();

  const isDesktop = breakpoint >= Breakpoint.xl;

  // --------- JSX

  if (isDesktop) {
    return <BookingCheckout parentRoute={parentRoute} />;
  }

  return (
    <ModalWrapper
      title="Check Out"
      parentRoute={parentRoute}
      content={<BookingCheckout parentRoute={parentRoute} />}
    />
  );
};

export default BookingCheckoutWrapper;
